module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMyIDMyIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cG9seWdvbiBmaWxsPSIjNGY5NWQwIiBwb2ludHM9IjE5LjQ0Myw1LjE3IDMwLjEzOCwxNS41IC0wLjA5NSwxNS41IC0wLjA5NSwxNi41IDMwLjEzOCwxNi41IDE5LjQ0MywyNi44MjkgMjAuMTM5LDI3LjU0OCAzMi4wOTUsMTYgMjAuMTM5LDQuNDUxICAgIj48L3BvbHlnb24+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/icons/arrow-right.svg
// module id = 579
// module chunks = 107818501498521